<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>Bids</li>
    </ul>
  </div>
  <div class="my_supplies_listing">
    <!-- TABLE-LISTING -->
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex="100" fxFlexFill>
        <!-- tables-section -->
        <section class="table_section">
          <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <perfect-scrollbar>
              <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                <!-- Position Column -->
                <ng-container matColumnDef="sNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>S.No</th>
                  <td mat-cell *matCellDef="let element;let i = dataIndex" data-label="S.No"> {{ i+1 }} </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="productName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                  <td mat-cell *matCellDef="let element" data-label="Product Name">
                    {{element.productName}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="bidStartDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Bid Start Date</th>
                  <td mat-cell *matCellDef="let element"data-label="Bid Start Date">
                    {{element.bidStartDate}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="bidEndDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Bid End Date</th>
                  <td mat-cell *matCellDef="let element" data-label="Bid End Date">
                    {{element.bidEndDate}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="sku">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU No</th>
                  <td mat-cell *matCellDef="let element" data-label="SKU No">
                    {{element.sku}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                  <td mat-cell *matCellDef="let element" data-label="action">
                    <img src="../../../../../../../assets/images/icons/table_down.svg" alt="">
                  </td>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="example-element-detail"
                      [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">                      
                        <div class="w-100" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                          fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                          <div fxLayout="column" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="25" fxFlex.sm="25"
                            fxFlex.xs="100" fxFlexFill></div>
                          <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
                            fxFlex.xs="100" fxFlexFill>
                            <table class="inner_table">
                              <thead>
                                <th>Bid Date</th>
                                <th>Bid Time</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>15/08/1999</td>
                                  <td>24:26</td>
                                </tr>
                                <tr>
                                  <td>15/08/1999</td>
                                  <td>24:26</td>
                                </tr>
                                <tr>
                                  <td>15/08/1999</td>
                                  <td>24:26</td>
                                </tr>
                                <tr>
                                  <td>15/08/1999</td>
                                  <td>24:26</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
                <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                  [class.example-expanded-row]="expandedElement === element"
                  (click)="expandedElement = expandedElement === element ? null : element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
              </table>
            </perfect-scrollbar>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
